var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 255,
    viewBox: "0 0 256 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.916 0.0722656C62.0836 0.0722702 66.1321 28.1875 66.1321 28.1875L66.2044 57.3145H128.072V66.0598H41.6307C41.6307 66.0598 0.144531 61.3549 0.144531 126.771C0.144527 192.188 36.3546 189.868 36.3546 189.868H57.965V159.512C57.965 159.512 56.8001 123.302 93.5968 123.302H154.959C154.959 123.302 189.434 123.859 189.434 89.9831V33.9695C189.434 33.9695 194.669 0.0722656 126.916 0.0722656ZM92.8018 19.6589C98.9572 19.6589 103.932 24.634 103.932 30.7894C103.932 36.9448 98.9572 41.9198 92.8018 41.9198C86.6464 41.9198 81.6713 36.9448 81.6713 30.7894C81.6713 24.634 86.6464 19.6589 92.8018 19.6589Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.757 254.126C193.589 254.126 189.54 226.011 189.54 226.011L189.468 196.884H127.6V188.139H214.042C214.042 188.139 255.528 192.843 255.528 127.427C255.528 62.0107 219.318 64.3305 219.318 64.3305H197.708V94.6862C197.708 94.6862 198.872 130.896 162.076 130.896H100.714C100.714 130.896 66.2383 130.339 66.2383 164.215V220.229C66.2383 220.229 61.004 254.126 128.757 254.126ZM162.871 234.539C156.715 234.539 151.74 229.564 151.74 223.409C151.74 217.254 156.715 212.279 162.871 212.279C169.026 212.279 174.001 217.254 174.001 223.409C174.001 229.564 169.026 234.539 162.871 234.539Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24.6874,
    y1: 22.9237,
    x2: 151.246,
    y2: 148.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 102.369,
    y1: 103.381,
    x2: 238.28,
    y2: 231.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.0934792163d56e233fb5f42cc69d7ed1.svg";
export { ForwardRef as ReactComponent };